import React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalBodyFontStyles, GlobalStylesWithGolos } from "../../globalStyles/globalStyles";
import { portalTheme } from "./portal.theme";
export var PortalThemeProvider = function PortalThemeProvider(_ref) {
  var children = _ref.children,
      withFonts = _ref.withFonts;
  return /*#__PURE__*/React.createElement(ThemeProvider // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  , {
    theme: portalTheme
  }, /*#__PURE__*/React.createElement(GlobalBodyFontStyles, null), withFonts && /*#__PURE__*/React.createElement(GlobalStylesWithGolos, null), children);
};